import { useState } from 'react';

interface OptionBarProps {
  selectedOptions: string[];
  onOptionsChange: (options: string[]) => void;
}

const OPTIONS = [
  { 
    id: '票务系统', 
    label: '票务系统', 
    description: '门票统计数据',
    icon: 'ri-ticket-line', 
    color: 'blue' 
  },
  { 
    id: '文旅客情数据', 
    label: '文旅客情数据', 
    description: '腾讯 LBS 画像数据',
    icon: 'ri-map-pin-line', 
    color: 'blue' 
  },
  { 
    id: '腾讯 We 分析数据', 
    label: '腾讯 We 分析数据', 
    description: '小程序使用数据',
    icon: 'ri-bar-chart-line', 
    color: 'blue' 
  },
  { 
    id: '天威客流数据', 
    label: '天威客流数据', 
    description: '实时客流及时长数据',
    icon: 'ri-team-line', 
    color: 'blue' 
  },
];

export default function OptionBar({ selectedOptions, onOptionsChange }: OptionBarProps) {
  const toggleOption = (optionId: string) => {
    if (selectedOptions.includes(optionId)) {
      // 如果当前只剩一个选项，不允许取消选择
      if (selectedOptions.length === 1) {
        return;
      }
      onOptionsChange(selectedOptions.filter(id => id !== optionId));
    } else {
      onOptionsChange([...selectedOptions, optionId]);
    }
  };

  const selectAll = () => {
    onOptionsChange(OPTIONS.map(opt => opt.id));
  };

  const clearAll = () => {
    onOptionsChange([]);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-gray-700">选择数据源</span>
      </div>

      <div className="grid grid-cols-4 gap-2">
        {OPTIONS.map((option) => {
          const isSelected = selectedOptions.includes(option.id);
          const isLastSelected = isSelected && selectedOptions.length === 1;
          return (
            <button
              key={option.id}
              onClick={() => toggleOption(option.id)}
              disabled={isLastSelected}
              className={`relative px-3 py-2.5 rounded-lg border transition-all ${
                isLastSelected ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
              } ${
                isSelected
                  ? 'border-blue-500 bg-blue-50/50 shadow-sm'
                  : 'border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50/30'
              }`}
              title={isLastSelected ? '至少需要选择一个数据源' : ''}
            >
              <div className="flex items-start gap-2">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  isSelected ? 'bg-blue-100' : 'bg-gray-100'
                }`}>
                  <i className={`${option.icon} ${isSelected ? 'text-blue-600' : 'text-gray-600'} text-sm`}></i>
                </div>
                <div className="flex-1 text-left">
                  <div className={`text-xs font-medium ${isSelected ? 'text-blue-700' : 'text-gray-700'}`}>
                    {option.label}
                  </div>
                  <div className={`text-xs mt-0.5 ${isSelected ? 'text-blue-600/70' : 'text-gray-500'}`}>
                    {option.description}
                  </div>
                </div>
              </div>
              {isSelected && (
                <div className="absolute top-1 right-1 w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
